import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {
  data: any = {};
  notifications: Array<any> = [];
  notificationDetail: Array<any> = [];
  error: any;
  notificationId: any;
  value: any;
  message: any;
  title: any;
  dateCreated: any;
  image: any;
  userID: string;
  mobNumber: any;
  loading: any;
  notificationList: any = [];
  private onDestroy$: Subject<void> = new Subject<void>();
  constructor(private serviceURLService: serviceURLService, private router: Router) {
    this.userID = localStorage.getItem('userID');
    this.mobNumber = localStorage.getItem('mobileNumber');
  }

  ngOnInit() {
    this.notification();
    //this.getUserNotification();
  }
  notification() {
    this.loading = true;
    this.data = {
      "updatedTime": null,
    }

    this.serviceURLService.newNotification(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      
      this.notifications = successData.response.notifications;
      // show notification only last week
      const newDate = new Date();
      newDate.setDate(newDate.getDate() - 7);
      const newTimestampDate = newDate.getTime();
      for (const notification of this.notifications) {
        // if (notification.updated > newTimestampDate) {
          this.notificationList.push(notification);
        // }
      }
      // for (let i = 0; i < (successData.response.notifications).length; i++) {
      //   this.notificationId = successData.response.notifications[i]._id;
      // }
      this.loading = false;
    }, errorData => {
    })
  };

  // getUserNotification() {
  //   this.serviceURLService.getUserNotification(this.mobNumber).subscribe((successData: any) => {

  //   }, errorData => {

  //   });
  // }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
}
